import { useState, useCallback } from 'react';
import { searchEntityUsers, type EntityUser } from '@services/editorApi.service';
import { useToast } from './useToast';

export const useUserSearch = (entityId?: string) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [searchResults, setSearchResults] = useState<EntityUser[]>([]);
  const [searching, setSearching] = useState(false);
  const { showError } = useToast();

  const handleSearch = useCallback(
    async (term: string) => {
      setSearchTerm(term);
      if (term.length < 2) {
        setSearchResults([]);
        return;
      }
      setSearching(true);
      try {
        const results = await searchEntityUsers(term, 'EXPERIMENT', entityId ?? '');
        setSearchResults(results);
      } catch (error) {
        setSearchResults([]);
        showError('Failed to search users. Please try again.');
      } finally {
        setSearching(false);
      }
    },
    [entityId, showError]
  );

  const clearSearch = useCallback(() => {
    setSearchTerm('');
    setSearchResults([]);
  }, []);

  return {
    searchTerm,
    setSearchTerm,
    searchResults,
    searching,
    handleSearch,
    clearSearch,
  };
};
